module.exports = __webpack_public_path__ + "static/media/freelanceri-at-cafe.64b69b13.webp";